import config from 'SRC/config/config.json'

export const genders = config.registrationForm.genders
